import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import {
  QueryClient,
  QueryClientProvider,
  MutationCache,
  QueryCache,
} from '@tanstack/react-query';
import { useMediaQuery } from 'usehooks-ts';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routes from './Routes';
import './styles/app.scss';
import stylesToast from './styles/toast.module.scss';
import DisplaySettings from './components/DisplaySettings';

const handleErrorRequest = (error: any) => {
  const url = error?.config?.url;
  const method = error?.config?.method;
  const statusCode = error?.response?.status;
  console.log('Request url', url);
  console.log('Request statusCode', statusCode);

  if (statusCode === 401) {
    localStorage.removeItem('token');
  }

  if (statusCode === 401 && !window.location.href.includes('/login')) {
    window.location.replace('/login');
  }

  if (
    /\/accounts\/login$/.test(url)
    || /\/accounts\/forgot-password$/.test(url)
    || /\/accounts\/reset-password/.test(url)
    || (method === 'post' && /\/accounts$/.test(url))
    || (method === 'put' && /\/formations/.test(url))
  ) return;

  if (statusCode === 406 && error?.response?.data?.error) {
    toast.error(error?.response?.data?.error);
  } else {
    toast.error('Un erreur est survenu');
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error: any) => {
      // error
      handleErrorRequest(error);
    },
  }),
  mutationCache: new MutationCache({
    // onSuccess: (d, p, context) => {
    //   console.log(d, p, context);
    // },
    onError: (error) => { // (error, _variables, _context, mutation)
      // if (mutation.options.onError) return;
      // console.log(error, _variables, _context, mutation);
      // console.log(error);
      handleErrorRequest(error);
    },
  }),
});

function App() {
  const isMobile = useMediaQuery('(max-width: 480px)');

  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <Router>
          <DisplaySettings />
          <Routes />
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
        <ToastContainer
          position='bottom-left'
          theme="dark"
          toastClassName={stylesToast.toast}
          progressClassName={stylesToast.progressBar}
          stacked
          autoClose={4000}
          style={!isMobile ? {
            width: '350px',
          } : {}}
        />
      </QueryClientProvider>
    </div>
  );
}

export default App;
